import React from 'react'

type ProgressBarType = {
  height?: string, width?: string, progress: number
}

const ProgressBar: React.FC<ProgressBarType> = ({height='80px', width='100%', progress=0}) => {
  return (
    <div style={{height, width}} className='block rounded-lg bg-gray-200'>
        <div className='bg-[#351E99] h-full rounded-lg' style={{width: `${progress}%`}}>
        </div>
    </div>
  )
}

export default ProgressBar